/* ==========================================================================
   RPBA cart drawer - put the variant on its own line. 24 Aug 2026.

   WHY
   Shopify's `item.title` is "Product Title - Variant Title", so the drawer
   renders "Dog IQ Puzzle Toy Feeder - Circular Pink" as one string and it wraps
   to two lines. Gymshark's bag (checked live, 24 Aug) puts the product name on
   one line and the variant beneath it in grey: "Butter Yellow M Light Support".
   Shorter, scannable, and it stops the name wrapping.

   WHY JAVASCRIPT AND NOT LIQUID
   The row is rendered in three places: snippets/minicart.liquid server-side, its
   own updateMinicartContent() re-render, and cart-addons.liquid's injectInto().
   Changing the markup means editing all three (46KB + 59KB of liquid). This
   rewrites the rendered row instead, which is what cart-addons.liquid already
   does for everything else in the drawer.

   WHY NOT JUST SPLIT ON " - "
   Product names legitimately contain " - ", so string-splitting guesses wrong.
   This reads /cart.js and uses the authoritative `product_title` and
   `variant_title` fields, matches rows by index, and only rewrites when the
   rendered text actually starts with product_title. If anything does not line
   up it leaves the row alone.

   Idempotent - marks each row with data-rpba-variant so re-renders and the
   MutationObserver cannot double-apply.
   ========================================================================== */
(function () {
  'use strict';

  var cache = null;
  var cacheAt = 0;

  function getCart() {
    var now = (window.performance && performance.now()) ? performance.now() : 0;
    if (cache && (now - cacheAt) < 1500) return Promise.resolve(cache);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cache = c; cacheAt = now; return c; })
      .catch(function () { return null; });
  }

  function applyRow(li, item) {
    if (!item || !item.variant_title) return;
    if (li.getAttribute('data-rpba-variant')) return;

    var h3 = li.querySelector('.product_name_mini');
    var a = h3 && h3.querySelector('a');
    if (!a) return;

    var text = (a.textContent || '').trim();
    var name = (item.product_title || '').trim();
    if (!name || text.indexOf(name) !== 0) return;   // not the row we think it is

    a.textContent = name;

    var v = document.createElement('div');
    v.className = 'rpba-variant';
    v.textContent = item.variant_title;
    h3.parentNode.insertBefore(v, h3.nextSibling);

    li.setAttribute('data-rpba-variant', '1');
  }

  function run() {
    var drawer = document.querySelector('.js-minicart.minicart');
    if (!drawer) return;
    var rows = drawer.querySelectorAll('.minicart_item li');
    if (!rows.length) return;

    getCart().then(function (cart) {
      if (!cart || !cart.items) return;
      for (var i = 0; i < rows.length && i < cart.items.length; i++) {
        try { applyRow(rows[i], cart.items[i]); } catch (e) { /* leave row alone */ }
      }
    });
  }

  function boot() {
    var drawer = document.querySelector('.js-minicart.minicart');
    if (!drawer) { setTimeout(boot, 300); return; }

    run();

    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 120);
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('.js-call-minicart, .quantity-btn, .remove-product, .rpba-card__add')) {
        setTimeout(run, 400);
        setTimeout(run, 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
